import { render, staticRenderFns } from "./ButtonSecondary.vue?vue&type=template&id=36a70970&scoped=true"
import script from "./ButtonSecondary.vue?vue&type=script&lang=ts"
export * from "./ButtonSecondary.vue?vue&type=script&lang=ts"
import style0 from "./ButtonSecondary.vue?vue&type=style&index=0&id=36a70970&prod&lang=scss&scoped=true"
import style1 from "./ButtonSecondary.vue?vue&type=style&index=1&id=36a70970&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a70970",
  null
  
)

export default component.exports